import { Component, OnInit, Input } from '@angular/core'
import { Router } from '@angular/router'
import { Subscription, Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

import { Alert, AlertType } from '../../models/alert'
import { AlertService } from '../../services/alert-service'

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent implements OnInit {
  @Input() id = 'default-alert'

  alert: Alert
  alertSubscription: Subscription

  private unsubscribe = new Subject()

  constructor(private alertService: AlertService) {
    this.alertService
      .getAlert()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((alert: Alert) => {
        this.alert = alert
      })
  }

  ngOnInit(): void {
    // this.alertSubscription = this.alertService.onAlert(this.id)
    // .subscribe(
    //   alert => {this.alerts.push(alert)
    // });
  }

  cssClass() {
    if (!this.alert) {
      return
    }

    switch (this.alert.type) {
      case AlertType.Error:
        return 'alert alert-danger'
    }
  }
}
